const siderBar = {
  profile: "Perfil",
  history: "História",
  setting: "Configurações",
  promotion: "Promoção",
};

export default siderBar;